export default __webpack_public_path__ + "static/media/BCAle.b81ea183.webp";